import { Box, Spinner } from '@chakra-ui/react'

export const LoadingOverlay = () => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      backgroundColor="rgba(0, 0, 0, 0.5)"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      zIndex="overlay"
    >
      <Spinner size="xl" color="white" />
    </Box>
  )
}
